var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reQuestion_detail_container"},[_vm._v("问答")])}
var staticRenderFns = []

export { render, staticRenderFns }